"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _InteractiveStreamQuestions = require("./InteractiveStreamQuestions");
Object.keys(_InteractiveStreamQuestions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _InteractiveStreamQuestions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _InteractiveStreamQuestions[key];
    }
  });
});